import CustomDataGrid from "../../../components/Shared/Table/CustomDataGrid";
import { sizeChartColumns } from "../../../components/Shared/Table/Columns";
import { setBasicDialogOpenFor } from "../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../store/hooks";
import { Button } from "../../../components/ui/button";
import { Sheet } from "../../../components/ui/sheet";
import { useSelector } from "react-redux";
import { basicDialogSelector } from "../../../store/helpers/helperSelectors";

interface KpiThreshold {
  id: number;
  name: string;
  green: string;
  yellow: string;
  red: string;
}

interface ICellKpiChartProps {
  kpiData: KpiThreshold[];
}


const CellKpiChart: React.FC<ICellKpiChartProps> = ({ kpiData }) => {
  const dispatch = useStoreDispatch();
  const basicDialogOpenFor = useSelector(basicDialogSelector);

  const handleClose = () => {
    dispatch(setBasicDialogOpenFor(undefined));
  };

  const footer = (
    <Button variant="outline" onClick={handleClose}>Close</Button>
  );

  return (
    <Sheet
      open={!!basicDialogOpenFor}
      onClose={handleClose}
      title="Threshold Info"
      footer={footer}
      width="600px"
    >
      <CustomDataGrid
        sx={{ height: "320px" }}
        tableId="cellKpiChart"
        rows={kpiData}
        columns={sizeChartColumns}
        disableColumnMenu={true}
        hideFooter={true}
        paginationMode="client"
      />
    </Sheet>
  );
};

export default CellKpiChart;
